import styled from '@emotion/styled'
import { css } from '@emotion/react'

const titleStyles = ({ theme }) => css`
  label: title;

  font-size: ${theme.typography.headings.tera.fontSize};
  line-height: ${theme.typography.headings.tera.lineHeight};
  font-weight: ${theme.font.weight.regular};
  color: ${theme.colors.n600};

  margin-bottom: ${theme.spacings.giga};
`

export const Title = styled('div')(titleStyles)
